// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__3TfjU","select":"SearchForm_select__3vtqf","input":"SearchForm_input__1lssn"};